<template>
  <tbody>
  <tr :class="['clickable', {updated: isLastVisited(channel.id), disabled: !isConfiguredOnContentSource && !channel.deleted, deleted: channel.deleted }]"
      @click="goToDetail()">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="channel.id"
             :value="channel.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label :for="channel.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Název' | translate" :class="['first_data']">
      <template v-if="!isConfiguredOnContentSource && !channel.deleted">
                <span class="dotted">
                    <strong>{{ channel.name }}</strong>
                    <translate class="help_popup help_popup--one-line">Tento kanál není nakonfigurovaný na žádném zdroji.</translate>
                </span>
      </template>
      <template v-else>
        <strong>{{ channel.name }}</strong>
      </template>
      <channel-video-quality-label :quality="channel.video_quality"></channel-video-quality-label>
      <channel-advertising-provider-channel-group-label
          :has-business-models="channel.has_business_models"
          :business-models="channel.business_models"
          @show-business-models="$emit('show-business-models', arguments[0])"
      />
    </td>
    <td :data-th="'Logo' | translate" class="image">
      <img v-if="channelLogoPath && !logoError" :src="channelLogoPath" @error="logoError = true">
    </td>
    <td :data-th="'ID' | translate">{{ channel.id }}</td>
    <td :data-th="'ID EPG' | translate">{{ channel.id_epg }}</td>
    <td :data-th="'Typ kanálu' | translate">{{ channelTypeList[channel.id_type] }}</td>
    <td :data-th="'V balíčcích a službách' | translate" v-if="inAnyChannelPackageOrService">
            <span class="dotted" @click.stop="$refs.channelpackagemodalref.showModal(true)">
                {{ channel.channel_packages_count }} / {{channel.services_count}}
              <modal ref="channelpackagemodalref">
                <div slot="title"><translate>V balíčcích a službách</translate> ({{channel.channel_packages_count}} / {{channel.services_count}})</div>
                <div slot="body">
                  <h4><translate class="translate">Balíčky</translate></h4>
                  <ul v-if="channel.channel_packages_count > 0">
                    <li v-for="(item, id) in channel.channel_packages" :key="'channel_package-'+id">
                      <entity-link :id="id" type="channelPackage">{{ item }}</entity-link>
                    </li>
                  </ul>
                  <ul v-else><li v-translate>Žádný balíček</li></ul>
                   <h4><translate class="translate">Služby</translate></h4>
                   <ul v-if="channel.services_count > 0">
                    <li v-for="(item, id) in channel.services" :key="'service-'+id">
                      <entity-link :id="id" type="service">{{ item }}</entity-link>
                    </li>
                  </ul>
                   <ul v-else><li v-translate>Žádná služba</li></ul>
                </div>
              </modal>
            </span>
    </td>
    <td :data-th="'V balíčcích a službách' | translate" v-else></td>
    <td :data-th="'Na zdrojích obsahů' | translate" v-if="isConfiguredOnContentSource">
      <span class="dotted" @click.stop="$refs.contentsourcemodalref.showModal(true)">
        {{ contentSourcesCount }}
        <modal ref="contentsourcemodalref">
          <div slot="title"><translate>Ve zdrojích obsahu</translate> ({{contentSourcesCount}})</div>
          <template slot="body">
            <table class="help_table">
              <thead>
                <tr>
                  <th v-translate>Hostname</th>
                  <th v-translate>Profil</th>
                  <th v-translate>Adresa</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in channel.channel_content_info">
                  <tr :key="index">
                    <td v-if="item.data.length > 0" :rowspan="item.data.length" class="nowrap">{{ item.hostname }}</td>
                    <td v-else class="nowrap">{{ item.hostname }}</td>
                    <td class="nowrap"><template v-if="item.data.length > 0">{{ item['data'][0].stream_profile }}</template></td>
                    <td><template v-if="item.data.length > 0">{{ item['data'][0].channel_address }}</template></td>
                  </tr>
                  <template v-if="item.data.length > 1">
                    <tr v-for="(d, index2) in item.data" v-if="index2" :key="index+'-'+index2">
                      <td class="nowrap">{{ d.stream_profile }}</td>
                      <td>{{ d.channel_address }}</td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </template>
        </modal>
      </span>
    </td>
    <td :data-th="'Na zdrojích obsahů' | translate" v-else></td>
    <td :data-th="'Váha' | translate">{{ channel.weight }}</td>
    <td :data-th="'Zámek' | translate" class="lock_td" v-if="isParentalLockActive && isEditable">
      <span class="dotted lock_icon" :title="$gettext('Odemknout')" @click.stop.prevent="updateLock">
        <img  class="is_set" src="../../../assets/images/lock.svg">
												<span class="help_popup">
													<strong v-translate>Vztahuje se na kanály</strong><br> {{ channel.lock_channel_names }}
												</span>
      </span>
      </td>
    <td :data-th="'Zámek' | translate" class="lock_td" v-else-if="!isParentalLockActive && isEditable">
      <span class="dotted lock_icon" :title="$gettext('Zamknout')" @click.stop.prevent="updateLock">
         <img class="is_set" src="../../../assets/images/unlock.svg">
                        <span class="help_popup">
                          <strong v-translate>Vztahuje se na kanály</strong><br> {{ channel.lock_channel_names }}
                        </span>
      </span>
    </td>
    <td :data-th="'Zámek' | translate" class="lock_td" v-else>
        <img v-if="isParentalLockActive" class="is_set" src="../../../assets/images/lock.svg">
        <img v-else class="is_set" src="../../../assets/images/unlock.svg">
    </td>
    <td :data-th="'Typ EPG' | translate">{{ channel.epg_type }}</td>
    <td :data-th="'Další informace' | translate" class="last_data">
          <span class="dotted more_info" v-if="showDetailInfo">
              <span class="help_popup">
                <div v-if="channel.last_import.timestamp"><strong><translate>Čas posledního importu:</translate></strong> {{ $_date_formatFull(channel.last_import.timestamp, false) }}<br></div>
                <div v-if="channel.last_import.broadcasts_count"><strong><translate>Počet naimportovaných broadcastů:</translate></strong> {{ channel.last_import.broadcasts_count }}<br></div>
              </span>
          </span>
    </td>
    <td class="no_padding"></td>
  </tr>
  </tbody>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import rowActions from "@/components/mixins/row-actions"

import ChannelVideoQualityLabel from "../../common/ChannelVideoQualityLabel";
import ChannelAdvertisingProviderChannelGroupLabel from "../../common/ChannelAdvertisingProviderChannelGroupLabel.vue";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "ChannelRow",
  mixins: [userSettings, rowActions],
  components: {EntityLink, ChannelAdvertisingProviderChannelGroupLabel, ChannelVideoQualityLabel},
  props: {
    isEditable: Boolean,
    channel: Object,
    channelDateUpdated: [String, Number],
    selectedChannels: Array
  },
  data: function () {
    return {
      moduleName: 'channels',
      minuteOptions: [
        {value: '00', text: '00'},
        {value: '15', text: '15'},
        {value: '30', text: '30'},
        {value: '45', text: '45'},
      ],
      channelTypeList: {
        1: this.$gettext('TV'),
        2: this.$gettext('Rádio')
      },
      logoError: false,
    }
  },
  created(ChannelService){
    this.channelService = ChannelService;
  },
  computed: {
    showDetailInfo(){
      return this.channel.last_import
          && (this.channel.last_import.timestamp || this.channel.last_import.broadcasts_count)
    },
    channelLogoPath() {
      return this.channel.logo_url
    },
    isParentalLockActive() {
      return Boolean(this.channel.parental_lock)
    },
    isChecked: function () {
      return this.selectedChannels.indexOf(String(this.channel.id)) > -1
    },
    isChannelHd() {
      return Boolean(this.channel.hd)
    },
    parentalLockIcon() {
      return this.isParentalLockActive ? '../../../assets/images/unlock.svg' : '../../../assets/images/lock.svg';
    },
    inAnyChannelPackageOrService() {
      return this.channel.channel_packages_count > 0 || this.channel.services_count > 0;
    },
    isConfiguredOnContentSource() {
      return Object.keys(this.channel.channel_content_info).length > 0
    },
    contentSourcesCount() {
      return Object.keys(this.channel.channel_content_info).length
    },
  },
  methods: {
    onChange: function (e) {
      this.$emit('select', e)
    },
    updateLock(){
      this.$emit('lock-update', this.channel.id, {lock: !this.isParentalLockActive})
    },
    goToDetail(e) {
      this.$router.push({name: 'channelDetail', params: {id: this.channel.id}})
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/channels/ChannelRow.vue